import React  from 'react';
import BaseVariables from '..';

function PayorAccessVariables() {
    return (
        <BaseVariables variableGroup="Payor Access" />
    )
}

export default PayorAccessVariables;
